module.exports = __webpack_public_path__ + "img/projects.6d33bb58.svg";